import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import Grid from "@mui/material/Grid";
import Card from "@mui/material/Card";
import CardActionArea from "@mui/material/CardActionArea";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import AddCircleRoundedIcon from "@mui/icons-material/AddCircleRounded";
import SportsSoccerRoundedIcon from "@mui/icons-material/SportsSoccerRounded";
import LeaderboardRoundedIcon from "@mui/icons-material/LeaderboardRounded";
import EmojiEventsRoundedIcon from "@mui/icons-material/EmojiEventsRounded";
import AppLayout from "../../components/ui/AppLayout";
import PageHeader from "../../components/ui/PageHeader";
import api from "../../api";
import tokens from "../../theme/tokens";

const acoes = [
  { to: "/cadastrar-jogo", title: "Cadastrar jogo", text: "Registre um novo confronto e o placar.", icon: <AddCircleRoundedIcon /> },
  { to: "/listar-jogos", title: "Jogos", text: "Edite jogos e lance gols, assistências e cartões.", icon: <SportsSoccerRoundedIcon /> },
  { to: "/classificacao", title: "Classificação", text: "Tabela dos grupos A e B, semifinais e final.", icon: <LeaderboardRoundedIcon /> },
  { to: "/classificacao/jogadores", title: "Artilharia e fair play", text: "Gols, assistências e cartões por jogador.", icon: <EmojiEventsRoundedIcon /> },
];

const AdminJogosPage = () => {
  const [torneio, setTorneio] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    api
      .get("/getTorneioActive")
      .then((response) => setTorneio(response.data?.nome))
      .catch((error) => console.error("Erro ao buscar torneio ativo:", error));
  }, []);

  return (
    <AppLayout>
      <PageHeader eyebrow="Gestão do torneio" title={torneio || "Torneio"} subtitle="Cadastre jogos e acompanhe a tabela." />
      <Grid container spacing={2}>
        {acoes.map((acao) => (
          <Grid item xs={12} sm={6} md={3} key={acao.to}>
            <Card sx={{ height: "100%" }}>
              <CardActionArea onClick={() => navigate(acao.to)} sx={{ height: "100%", p: 3, display: "flex", flexDirection: "column", alignItems: "flex-start", justifyContent: "flex-start" }}>
                <Box sx={{ width: 48, height: 48, borderRadius: 3, bgcolor: tokens.color.brandSoft, color: tokens.color.brand, display: "grid", placeItems: "center", mb: 2 }}>
                  {acao.icon}
                </Box>
                <Typography variant="h6">{acao.title}</Typography>
                <Typography variant="body2" color="text.secondary" sx={{ mt: 0.5 }}>{acao.text}</Typography>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>
    </AppLayout>
  );
};

export default AdminJogosPage;
